import React from "react";
import TeamCards from "../cards/TeamCards";

// Data \\
import data from "../../assets/data/teamMembers.json";

// Style \\
import "../../assets/styles/sections/team.scss";

import { Navigation, A11y } from "swiper/modules";

//  $$ Swipper $$ \\
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Team = () => {
  return (
    <section className="team">
      <div className="containers">
        <div className="team_items">
          <div className="title text-center text-black">
            <h3>Our Team Members</h3>
            <p className="text-xl w-2/4 my-2 mx-auto text-black">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio
              itaque labore totam dolores sapiente expedita?
            </p>
          </div>

          <div className="swipper_box">
            <Swiper
              className="swiper"
              modules={[Navigation, A11y]}
              // spaceBetween={20}
              breakpoints={{
                992: {
                  spaceBetween: 20,
                  slidesPerView: 3,
                },
                768: {
                  spaceBetween: 10,
                  slidesPerView: 2,
                },
                576: {
                  spaceBetween: 5,
                  slidesPerView: 1,
                },
              }}
              navigation
              pagination={{ clickable: true }}
              // scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {data.map((data, index) => (
                <SwiperSlide className="slideSwipper">
                  <TeamCards key={data.id} data={data} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
